export default __webpack_public_path__ + "static/media/logo.5dea2f7f.svg";